import React from "react";
import { Navigate } from "react-router-dom";
import { IsAuthenticated } from "./utils/_helpers";
const PrivateRoute = ({ children }) => {
  return IsAuthenticated() ? children : <Navigate to="/login" />;
};
export default PrivateRoute;
